export default "__VITE_ASSET__Bu2zuge5__"